import { forwardRef } from "react";
import type { PropsWithChildren, ReactNode } from "react";
import styles from "../styles.module.scss";

type Props = {
  title: string;
  children: ReactNode;
  ref: React.ForwardedRef<HTMLDivElement>;
};

export const GridItemContainerMobile = forwardRef<HTMLDivElement, PropsWithChildren<Props>>(
  ({ children, title }, ref) => {
    return (
      <div className={styles.root} ref={ref}>
        <div className={title === "Calendar" ? styles["calendar-header"] : styles.header}>
          <div className={styles.title}>{title}</div>
        </div>
        {children}
      </div>
    );
  },
);
